import React, { Component } from "react";

export default class TeamLeadImg extends Component {
  render() {
    const theme = this.props.theme;
    const { width = "90%", height = "auto" } = this.props;
    
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 677.143 467.935"
        role="img"
        style={{ maxWidth: "100%", height: "auto" }}
      >
        <g transform="translate(-684.638 -283.183)">
          <path 
            d="M0,624.089a1.012,1.012,0,0,0,1.1.9h674.94a.918.918,0,1,0,0-1.8H1.1A1.017,1.017,0,0,0,0,624.089Z" 
            transform="translate(684.638 126.129)" 
            fill="#e6e6e6"
          />
          <path 
            d="M358.106,306.427l-.828,1.032-5.368,6.659-56.31,69.8L200.048,525.256l-13.658.064,95.6-141.4,65.149-80.768,4.766,1.423,5.368,1.6Z" 
            transform="translate(797.659 224.002)" 
            fill="#f2f2f2"
          />
          <path 
            d="M581.557,525.32l-11.241-.064L474.757,383.918,419.93,315.949l-6.844-8.49-.836-1.032.836-.25,6.844-2.045,3.29-.982,64.17,80.768Z" 
            transform="translate(741.852 224.002)" 
            fill="#f2f2f2"
          />
          <rect 
            width="385.276" 
            height="212.17" 
            transform="translate(963.127 351.607)" 
            fill={theme.text}
          />
          <rect 
            width="370.511" 
            height="198.859" 
            transform="translate(970.325 358.27)" 
            fill="#fff"
          />
          <rect 
            width="80" 
            height="16" 
            rx="6" 
            transform="translate(1116 395)" 
            fill={theme.imageHighlight}
          />
          <g 
            transform="translate(1155 411)" 
            fill="#fff" 
            stroke="#707070" 
            strokeLinecap="round" 
            strokeWidth="1"
          >
            <rect width="1" height="32" stroke="none"/>
            <rect x="0.5" y="0.5" height="31" fill="none"/>
          </g>
          <line 
            x2="192" 
            transform="translate(1059.581 427)" 
            fill="none" 
            stroke="#707070" 
            strokeWidth="1"
          />
          <rect 
            width="56" 
            height="12" 
            rx="6" 
            transform="translate(1032 443)" 
            fill="#e6e6e6"
          />
          <rect 
            width="56" 
            height="12" 
            rx="6" 
            transform="translate(1224 443)" 
            fill={theme.imageHighlight}
          />
          <rect 
            width="56" 
            height="12" 
            rx="6" 
            transform="translate(1128 443)" 
            fill="#e6e6e6"
          />
          <line 
            x2="0.081" 
            y2="17" 
            transform="translate(1251.5 426.5)" 
            fill="none" 
            stroke="#707070" 
            strokeWidth="1"
          />
          <line 
            x2="0.081" 
            y2="17" 
            transform="translate(1059.919 426.5)" 
            fill="none" 
            stroke="#707070" 
            strokeWidth="1"
          />
          <line 
            x2="0.081" 
            y2="17" 
            transform="translate(1052 455)" 
            fill="none" 
            stroke="#707070" 
            strokeWidth="1"
          />
          <line 
            x2="64" 
            transform="translate(1019.918 472)" 
            fill="none" 
            stroke="#707070" 
            strokeWidth="1"
          />
          <line 
            y2="17" 
            transform="translate(1083.5 471.5)" 
            fill="none" 
            stroke="#707070" 
            strokeWidth="1"
          />
          <line 
            y2="17" 
            transform="translate(1019.918 471.5)" 
            fill="none" 
            stroke="#707070" 
            strokeWidth="1"
          />
          <rect 
            width="32" 
            height="12" 
            rx="6" 
            transform="translate(1004 488)" 
            fill="#e6e6e6"
          />
          <rect 
            width="32" 
            height="12" 
            rx="6" 
            transform="translate(1068 488)" 
            fill={theme.imageHighlight}
          />
          <line 
            x2="0.081" 
            y2="17" 
            transform="translate(1155 455)" 
            fill="none" 
            stroke="#707070" 
            strokeWidth="1"
          />
          <line 
            y1="0.5" 
            x2="88.1" 
            transform="translate(1122.918 471.5)" 
            fill="none" 
            stroke="#707070" 
            strokeWidth="1"
          />
          <line 
            y2="17" 
            transform="translate(1166.5 471.5)" 
            fill="none" 
            stroke="#707070" 
            strokeWidth="1"
          />
          <line 
            y2="17" 
            transform="translate(1122.918 471.5)" 
            fill="none" 
            stroke="#707070" 
            strokeWidth="1"
          />
          <rect 
            width="32" 
            height="12" 
            rx="6" 
            transform="translate(1107 488)" 
            fill={theme.imageHighlight}
          />
          <rect 
            width="32" 
            height="12" 
            rx="6" 
            transform="translate(1151 488)" 
            fill="#e6e6e6"
          />
          <line 
            x2="0.081" 
            y2="17" 
            transform="translate(1260 455)" 
            fill="none" 
            stroke="#707070" 
            strokeWidth="1"
          />
          <line 
            x2="31.418" 
            transform="translate(1259.5 472)" 
            fill="none" 
            stroke="#707070" 
            strokeWidth="1"
          />
          <line 
            y2="17" 
            transform="translate(1290.5 471.5)" 
            fill="none" 
            stroke="#707070" 
            strokeWidth="1"
          />
          <rect 
            width="32" 
            height="12" 
            rx="6" 
            transform="translate(1275 488)" 
            fill="#e6e6e6"
          />
          <line 
            y2="17" 
            transform="translate(1210.5 471.5)" 
            fill="none" 
            stroke="#707070" 
            strokeWidth="1"
          />
          <rect 
            width="32" 
            height="12" 
            rx="6" 
            transform="translate(1195 488)" 
            fill={theme.imageHighlight}
          />
          <g transform="translate(-908 -88.816)">
            <path 
              d="M292.829,299.989c1.4,7.032,6.4,11.594,11.171,10.184s7.5-8.26,6.1-15.292a15.847,15.847,0,0,0-3.583-7.522l-6.327-29.689-14.795,4.876L293.2,291.3a17.815,17.815,0,0,0-.357,8.691h0Z" 
              transform="translate(1453.557 328.02)" 
              fill="#f8a8ab"
            />
            <rect 
              width="17.365" 
              height="24.638" 
              transform="translate(1730.405 823.216) rotate(180)" 
              fill="#f8a8ab"
            />
            <path 
              d="M268.9,555.485c-2.969.265-17.83,1.443-18.576-1.965a14.6,14.6,0,0,1,.464-6.842c1.426-14.214,1.957-14.372,2.281-14.463.506-.149,1.982.556,4.379,2.1l.149.1.033.174c.041.224,1.1,5.44,6.137,4.636,3.45-.547,4.569-1.31,4.926-1.684a2.121,2.121,0,0,1-.912-.763,2.668,2.668,0,0,1-.191-2.222,34.531,34.531,0,0,1,2.67-6l.224-.4,19.737,13.318,12.191,3.483a3.141,3.141,0,0,1,2.032,1.8h0a3.144,3.144,0,0,1-.8,3.549c-2.214,1.99-6.609,5.4-11.229,5.822-1.227.116-2.853.158-4.677.158-7.621,0-18.75-.788-18.833-.8Z" 
              transform="translate(1459.583 281.845)" 
              fill={theme.text}
            />
            <rect 
              width="17.365" 
              height="24.638" 
              transform="translate(1682.298 823.216) rotate(180)" 
              fill="#f8a8ab"
            />
            <path 
              d="M210.888,555.485c-2.969.265-17.83,1.443-18.576-1.965a14.6,14.6,0,0,1,.464-6.842c1.426-14.214,1.957-14.372,2.281-14.463.506-.149,1.982.556,4.379,2.1l.149.1.033.174c.041.224,1.1,5.44,6.137,4.636,3.45-.547,4.569-1.31,4.926-1.684a2.121,2.121,0,0,1-.912-.763,2.668,2.668,0,0,1-.191-2.222,34.533,34.533,0,0,1,2.67-6l.224-.4,19.737,13.318,12.191,3.483a3.141,3.141,0,0,1,2.032,1.8h0a3.144,3.144,0,0,1-.8,3.549c-2.214,1.99-6.609,5.4-11.229,5.822-1.227.116-2.853.158-4.677.158-7.621,0-18.75-.788-18.833-.8Z" 
              transform="translate(1469.486 281.845)" 
              fill={theme.text}
            />
            <path 
              d="M213.11,94.123l26.927,8.849V64.21H215.606Z" 
              transform="translate(1465.896 361.045)" 
              fill="#f8a8ab"
            />
            <circle 
              cx="26.828" 
              cy="26.828" 
              r="26.828" 
              transform="translate(1675.771 382.33)" 
              fill="#f8a8ab"
            />
            <path 
              d="M227.646,39.249l3.7,4.486,6.692-11.71s8.542.44,8.542-5.9,7.837-6.518,7.837-6.518S265.5.247,242.531,5.347c0,0-15.931-10.913-23.859-1.584,0,0-24.3,12.232-17.341,33.537l11.552,21.96,2.621-4.967s-1.584-20.865,12.149-15.052Z" 
              transform="translate(1468.12 372.008)" 
              fill={theme.text}
            />
            <path 
              d="M257.6,254.19H166.98l22.175,228.628,25.708-1.659,1.269-164.648,16.179,72.256,4.735,91.148,23.428,1.244,2.72-103.686Z" 
              transform="translate(1473.771 328.614)" 
              fill={theme.text}
            />
            <path 
              d="M203.767,83.19l30.684,7.464,26.23,113.356L257.6,225l-76.834,13L166.98,225Z" 
              transform="translate(1473.771 357.805)" 
              fill="#e6e6e6"
            />
            <path 
              d="M195.224,76.35l-9.429,11.768-19.126,5.108-8.647,173.156h38.871l19.93-164Z" 
              transform="translate(1478.075 358.973)" 
              fill={theme.text}
            />
            <path 
              d="M246.737,83.44,239.83,101.8l25.113,176.059h11.98L271.4,106.693,255.129,92.6Z" 
              transform="translate(1464.213 357.762)" 
              fill={theme.text}
            />
            <path 
              d="M268.068,108.868l10.524,2.164s4.611,1.692,6.286,14.795,1.965,57.105,1.965,57.105l17.9,70.987-20.326,6.7-9.57-38.2L268.06,108.86Z" 
              transform="translate(1456.516 353.423)" 
              fill={theme.text}
            />
            <path 
              d="M240.49,96.927l-4.623,9.338L245.113,215.8l-10.79,11.038L224.3,216.652l7.327-109.964L220.95,96.927l3.735-2.977,3.855,5.092,7.711-1.692,3.08-5.1Z" 
              transform="translate(1466.652 352.386)" 
              fill={theme.text}
            />
            <path 
              d="M181.909,266.987c4.271,5.764,10.739,7.746,14.446,4.437s3.251-10.665-1.02-16.437a15.739,15.739,0,0,0-6.46-5.266l-18.41-24.141L159.17,236.311l19.347,22.656a17.852,17.852,0,0,0,3.392,8.011h0Z" 
              transform="translate(1475.104 333.498)" 
              fill="#f8a8ab"
            />
            <path 
              d="M174.465,99.345,166.056,96.7s-11.394,2.828-15.168,17.059L132.47,183.087l31.239,54.833L180.4,217.652,164.68,167.314l9.794-67.969Z" 
              transform="translate(1479.662 355.499)" 
              fill={theme.text}
            />
          </g>
        </g>
      </svg>
    );
  }
}
